import { CSSVariablesResolver, MantineThemeOverride } from '@mantine/core';
import { darkTokens, lightTokens } from './tokens';

/**
 * Global Mantine theme configuration.
 * Defines the core design system attributes like typography and primary colors.
 */
export const theme: MantineThemeOverride = {
  fontFamily: "'Source Sans 3', sans-serif",
  headings: {
    fontFamily: "'Orbitron', sans-serif",
  },
  primaryColor: 'blue',
  defaultRadius: 'md',
};

/**
 * Resolves CSS variables for both light and dark color schemes.
 * It maps our custom tokens to CSS variables that are automatically
 * injected by Mantine based on the current color scheme.
 */
export const cssVariablesResolver: CSSVariablesResolver = () => {
  const shared = Object.keys(darkTokens).reduce(
    (acc, key) => {
      acc[key] = '';
      return acc;
    },
    {} as Record<string, string>
  );

  const dark = { ...shared };
  const light = { ...shared };

  for (const key of Object.keys(darkTokens) as (keyof typeof darkTokens)[]) {
    dark[key] = darkTokens[key];
    light[key] = lightTokens[key];
  }

  return {
    variables: {},
    dark,
    light,
  };
};
